<template>
  <div>
    <v-col cols="12" class="persona px-0 px-sm-3 my-sm-10 my-md-5">
      <v-row wrap>
        <v-col
          cols="12"
          sm="6"
          md="7"
          :class="[
            'persona--text px-sm-8',
            { 'px-15': !['xs', 'sm'].includes($mq) },
            imgPos === 'right' || ['xs', 'sm'].includes($mq)
              ? 'order-last'
              : 'order-first',
          ]"
        >
          <h2 class="display-1 font-weight-bold mb-2">{{ title }}</h2>
          <div v-if="subtitle" class="headline font-italic mb-2">{{
            subtitle
          }}</div>
          <div v-if="desc" class="font-italic mb-2">{{ desc }}</div>
          <!-- <div class="mb-4">{{ location }}</div> -->
          <p class="headline mt-4"
            ><v-icon left color="grey darken-2">mdi-format-quote-open</v-icon
            >{{ body
            }}<v-icon right color="grey darken-2"
              >mdi-format-quote-close</v-icon
            ></p
          >
          <v-col cols="12" class="pl-0">
            <div v-if="instagram" class="ig"
              ><v-btn
                :href="`https://instagram.com/${instagram}`"
                color="grey lighten-4"
                depressed
                ><v-icon left>mdi-instagram</v-icon>{{ instagram }}</v-btn
              ></div
            >
          </v-col>
        </v-col>
        <v-col
          cols="12"
          md="5"
          sm="6"
          :class="[`mb-4`, { hiddenImg: !imgLoaded }, 'px-0']"
        >
          <v-img
            :src="img"
            :alt="`Photo of ${title}`"
            :class="[`persona--img`, { left: imgPos !== 'right' }]"
            contain
            aspect-ratio="1"
            @load="imgLoaded = true"
          />
          <div
            v-if="caption"
            class="body-2 text-center mt-1 font-italic"
            v-html="caption"
          />
        </v-col>
      </v-row>
      <v-row v-if="minimartLink">
        <v-col cols="12" class="text-center">
          <v-btn
            :href="minimartLink"
            target="_blank"
            large
            outlined
            class="my-2"
            color="deep-orange darken-2"
          >
            Order on Minimart
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-divider />
  </div>
</template>

<script>
export default {
  name: 'PersonaSection',
  props: {
    imgPos: {
      type: String,
      default: 'left',
    },
    img: {
      type: String,
      required: true,
      default: '',
    },
    caption: {
      type: String,
      default: null,
    },
    instagram: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: null,
    },
    desc: {
      type: String,
      default: null,
    },
    minimartLink: {
      type: String,
      default: null,
    },
    location: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
  },
  components: {},
  data() {
    return {
      imgLoaded: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.persona {
  @media (min-width: 1264px) {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
}
.persona--img {
  transition: opacity 1.2s, transform 1.2s ease-in-out;
}
.hiddenImg {
  .persona--img {
    opacity: 0;
    transform: translateX(-20px);
    &.left {
      transform: translateX(20px);
    }
  }
}
</style>
